<template>
  <div class="couponVOListBox">
    <ul>
      <li v-for="(item, index) in couponVOList" :key="index">
        <p class="vipLabel" v-if="item.fitUser !== 1">
          {{ item.fitUser === 2 ? '新用户专享' : '老用户专享' }}
        </p>
        <div class="left">
          <p class="discountAmount" v-if="item.discountType === 1">
            <span>￥</span>{{ item.discountAmount }}
          </p>
          <p class="discountAmount" v-else>{{ item.discountAmount }}<span>折</span></p>
          <p>满{{ item.usableCondition }}可用</p>
        </div>
        <div class="right">
          <p class="frontEndName">{{ item.frontEndName }}</p>
          <p class="status">
            <span v-if="item.productionFitType === 1">所有产品可用</span>
            <span v-else-if="item.productionFitType === 2 || item.productionFitType === 3"
              >指定产品可用</span
            >
            <span v-else-if="item.productionFitType === 4">所有套餐可用</span>
            <span v-else>指定产品套餐可用</span>
            <span
              :class="['receive', item.hasGetAlready === 1 ? 'receiveOK' : '']"
              @click="receive(item.couponId, item.hasGetAlready)"
              >{{ item.hasGetAlready === 1 ? '已领取' : '领取' }}</span
            >
          </p>
          <p v-if="item.effectiveTimeType === 1">领取后{{ item.effectiveDays }}天有效</p>
          <p v-else>
            {{ detailTime(item.effectiveTimeBegin) }} - {{ detailTime(item.effectiveTimeEnd) }}
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { reqReceiveCoupon } from '@/api/coupon/index';
import { dateTime } from '@/utils/tools';

export default {
  data() {
    return {};
  },
  props: ['couponVOList'],
  methods: {
    async receive(id, hasGetAlready) {
      if (hasGetAlready === 1) return;
      const data = await reqReceiveCoupon({
        couponId: id,
        fitPlatform: 1,
        fitEndPoint: 4,
        isLink: 0,
        terminalMark: this.$global.terminalMark,
      });
      if (data.code === 0) {
        this.$toast('优惠券领取成功，请在个人中心查看');
        this.$emit('resetCoupon');
        window.sessionStorage.setItem('receiveCouponId',id)
      } else {
        this.$toast(`${data.msg}`);
      }
    },
    detailTime(time) {
      const { year, month, day, h, m } = dateTime(new Date(time.replace(/-/g, '/')).getTime());
      return `${year}-${month}-${day}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.couponVOListBox {
  width: 100%;
  padding: 0 36px 36px;
  ul {
    li {
      position: relative;
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 196px;
      margin-top: 20px;
      color: #787878;
      font-size: 22px;
      background: linear-gradient(180deg, #fff1cd 0%, #ffe6b3 100%);
      border-radius: 14px;
      .vipLabel {
        position: absolute;
        top: 2px;
        left: 2px;
        width: 105px;
        height: 33px;
        font-size: 15px;
        line-height: 33px;
        text-align: center;
        background: #fff0e6;
        border-radius: 5px 0 7px 0;
      }
      .left {
        display: flex;
        flex-shrink: 0;
        flex-wrap: wrap;
        align-content: center;
        align-items: center;
        box-sizing: border-box;
        width: 194px;
        p {
          width: 100%;
          text-align: center;
        }
        .discountAmount {
          color: #894e0f;
          font-weight: normal;
          font-size: 44px;
          line-height: 52px;
          span {
            font-size: 22px;
          }
        }
      }
      .right {
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        align-items: center;
        width: 69%;
        height: 90%;
        margin: 10px 10px 0 0;
        padding: 18px 22px;
        padding-top: 0;
        background: url('../../../assets/img/live/coupon-newBg.png') no-repeat;
        background-size: 100% 100%;
        p {
          width: 100%;
        }
        .frontEndName {
          padding-bottom: 12px;
          overflow: hidden;
          color: #333;
          font-weight: 500;
          font-size: 26px;
          line-height: 36px;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .status {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-bottom: 12px;
          line-height: 30px;
          .receive {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 96px;
            height: 43px;
            color: #fff;
            background: #ff6c02;
            border-radius: 33px;
          }
          .receiveOK {
            background: #ccc;
          }
        }
      }
    }
  }
}
</style>
